import graphql from "babel-plugin-relay/macro";
import { useCallback } from "react";

import { useMutationWithError } from "@/utils/hooks/useMutationWithError";

import {
  CreateDiningBookingInput,
  useCreateDraftDiningBookingMutation,
} from "./__generated__/useCreateDraftDiningBookingMutation.graphql";

export const useCreateDraftDiningBooking = () => {
  const [createDraftDiningBooking, isCreatingDraftDiningBooking] =
    useMutationWithError<useCreateDraftDiningBookingMutation>(
      useCreateDraftDiningBookingMutationString
    );

  const handleCreateDraftDiningBooking = useCallback(
    (
      input: CreateDiningBookingInput,
      onSuccess?: (bookingId: string) => void
    ) => {
      createDraftDiningBooking({
        variables: { input: { ...input, isDraft: true } },
        onCompleted: (res) => {
          if (res?.responsePayload?.success) {
            const bookingId = res?.responsePayload?.booking?.id;
            if (bookingId) {
              onSuccess?.(bookingId);
            }
          }
        },
      });
    },
    [createDraftDiningBooking]
  );
  return [
    handleCreateDraftDiningBooking,
    isCreatingDraftDiningBooking,
  ] as const;
};

const useCreateDraftDiningBookingMutationString = graphql`
  mutation useCreateDraftDiningBookingMutation(
    $input: CreateDiningBookingInput!
  ) {
    responsePayload: createDiningBooking(input: $input) {
      booking {
        id
      }
      errors {
        field
        code
        message
      }
      success
    }
  }
`;
